import { render, staticRenderFns } from "./CostSlot.vue?vue&type=template&id=bed37cf8&"
import script from "./CostSlot.vue?vue&type=script&lang=js&"
export * from "./CostSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports